/**
 * 使用范围
 * 场次打印
 * */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
// desc 场次打印信息详情-数据
const priceTagData = {
    tableData: [],
    tableTotal: 0,
    show: false,
};
export default createStore({
    state: Object.assign({}, priceTagData),
    effects: {
        // 联播场次打印
        priceDetail(params, { state, rootState }) {
            API.auction.getPriceDetails({
                roundId: rootState.router.query.id,
                status: 0,
            })
                .then((res) => {
                const tableData = res;
                const tableTotalNum = res.length;
                this.SET_STATE({
                    tableData,
                    tableTotal: tableTotalNum,
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        SHOWPRINTPIRCETAG(state, payload) {
            state.show = true;
        },
        HIDEPRINTPIRCETAG(state) {
            state.show = false;
        },
    },
});
